import { update } from '@kundinos/nanostores';

import { modulesStore } from './stores';

import type { ModuleProductData } from '@Types/ModuleProduct';

const editModules = (modules: ModuleProductData[]) => {
  update(modulesStore, (prevModules) => {
    return prevModules.map((prevModule) => {
      const newModule = modules.find((module) => module.id === prevModule.id);
      if (!newModule) return prevModule;
      return newModule;
    });
  });
};

export default editModules;
